import React, {Component} from 'react';
import RecurveUtility from '../../functions/utility';

export default class BootstrapModal extends Component {
    constructor(props) {
        super(props);
        this.utility = {...RecurveUtility};
        this.id = Math.floor(Math.random() * 1000).toString() + Date.now().toString();
    }

    // componentDidMount() {
    //     window.$(`#${this.id}`).modal('show');
    // }
    //
    // componentWillUnmount() {
    //     window.$(`#${this.id}`).modal('dispose');
    //     window.$('.modal-backdrop').remove();
    // }

    render() {
        return (
        <div id={this.id} className="modal" tabIndex="-1" data-backdrop='static' role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content card">
                    <div className="modal-header">
                        <h5 className="modal-title">{this.props.title}</h5>
                        <button onClick={this.props.closeFunction} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body card-body">
                        {this.props.bodyContent}
                    </div>
                    <div className="modal-footer">
                        <button onClick={this.props.closeFunction} type="button" className={this.props.oneButton ? "btn btn-primary" : "btn btn-secondary"} data-dismiss="modal">{this.props.closeText ? this.props.closeText : 'Dismiss'}</button>
                        {this.props.proceedFunction ? <button onClick={this.props.proceedFunction} type="button" className="btn btn-primary">{this.props.proceedText ? this.props.proceedText : 'Proceed'}</button> : ''}
                    </div>
                </div>
            </div>
        </div>
        );
    }
}
